module.exports = __webpack_public_path__ + "img/section7_bg_img.6db8208e.jpg";